<template>
  <section>
    <div class="d-flex justify-content-between flex-wrap" style="margin-bottom: 24px; gap: 4px">
      <h2>Team</h2>

      <div class="search-input-container">
        <IconMagnifyingGlass />
        <input
          v-model="searchValue"
          class="form-control"
          type="text"
          placeholder="Search for name, title..."
          @input="debouncedSearch"
        />
      </div>
    </div>

    <div class="d-flex justify-content-between mb-2 align-items-center" style="height: 44px">
      <div v-if="peopleModalStore.items.length > 0">
        Showing 1 -
        {{
          peopleModalStore.size <= peopleModalStore.totalResults
            ? peopleModalStore.size
            : peopleModalStore.totalResults
        }}
        of {{ peopleModalStore.totalResults }} results
      </div>
      <div v-else> 0 results </div>
      <div class="control">
        <button class="btn btn-light pb-2" @click="peopleModalStore.setViewAllPreview()"
          >View All</button
        >
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import debounce from 'lodash/debounce'
import { usePeopleModalStore } from '~/stores/modals/people-modal'

const loadStore = useLoadingStore()
const peopleModalStore = usePeopleModalStore()

const searchValue = ref(peopleModalStore.searchValue)
const debouncedSearch = debounce(() => peopleModalStore.setSearchValue(searchValue.value), 1000)
</script>
